export default {
      id: "arrow_down-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite.svg#arrow_down",
      toString: function () {
        return this.url;
      }
    }